<template>
  <div v-if="data?.toolbar" class="desktop-toolbar-spacesaver position-relative">
    <nav class="navbar navbar-expand-xl bg-white desktop-navbar-fixed-top" style="min-height:61px" aria-label="תפריט ראשי" :inert="showPopup || inert ? true : undefined">
      <div class="container-fluid mw1180 position-relative">

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainmenu" aria-controls="mainmenu" :aria-expanded="mainMenuExpanded ? 'true' : 'false'" aria-label="תפריט ניווט">
          <!-- <span class="navbar-toggler-icon"></span> -->
          <img :src="menuIcon" alt="" class="toolbar-icon" aria-hidden="true" />
        </button>
        <button type="button" class="btn dropdown-toggle" id="userDropdownMenu" data-bs-toggle="dropdown" :aria-expanded="userMenuExpanded ? 'true' : 'false'" aria-label="תפריט משתמש">
          <span v-if="$isDesktop() && userGreetingsHtml" class="df20-l20" v-html="userGreetingsHtml"></span>
          <SvgImage :src="$responsive(data.toolbar).menu.user.icon" width="25px" />
        </button>
        <ul class="dropdown-menu" aria-labelledby="userDropdownMenu" dir="rtl">
          <li v-for="(item, idx) in $responsive(data.toolbar).menu.user.menu" :key="idx" style="text-align:right;">
            <a v-if="item.href && item.href!='/users/logout'" class="dropdown-item f20-l20" :class="{ 'bold': item.bold }" :href="item.href" v-html="item.text"></a>
            <span v-if="item.href=='/users/logout'" class="dropdown-item f20-l20"><button type="button" class="dropdown-logout-btn f20-l20" @click="serverFetch(item.href)" v-html="item.text"></button></span>
            <span v-if="item.text_html" class="dropdown-item f20-l20"  v-html="item.text_html"></span>
          </li>
        </ul>
        <button type="button" class="btn" @click="searchPopup()" aria-label="חיפוש"><img src="@/assets/icons/header-search.svg" alt="" aria-hidden="true" /></button>
        <button type="button" class="toolbar-cart-btn" @click="clickCart" :aria-label="cartAriaLabel">
          <span class="toolbar-cart-icon-wrap">
            <SvgImage :src="$responsive(data.toolbar).cart.icon" alt="" aria-hidden="true" />
            <span v-if="cartQuantity>0" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-red" aria-hidden="true">
              {{cartQuantity}}
            </span>
          </span>
        </button>
        <span class="visually-hidden" aria-live="polite" aria-atomic="true">{{ cartLiveMessage }}</span>
        <span class="flex-grow-1"></span>
        <router-link to="/" class="navbar-brand white-link mobile-or-tablet"><img src="@/assets/logo.png" alt="יאמי" /></router-link>
        <div class="collapse navbar-collapse" id="mainmenu" dir="rtl">
          <ul class="navbar-nav me-auto w-100 mb-2 mb-lg-0">
            <li class="nav-item text-right bottom-splitter" v-for="(item, idx) in $responsive(data.toolbar).menu.main" :key="idx">
              <a v-if="item.href" class="nav-link f20-l20 black-link" :href="item.href">{{ item.text }}</a>
              <span v-if="item.text_html" class="dropdown-item f20-l20 fw-bold" :class="{ 'bold': item.bold }" v-html="item.text_html"></span>
            </li>
          </ul>
        </div>
        <router-link to="/" class="navbar-brand white-link desktop-only" style="margin-right:0;"><img src="@/assets/logo.png" alt="יאמי" /></router-link>
      </div>
      <HorizontalSplitter class="show position-absolute" id="toolbarBottomSplitter" style="bottom:1px;" />
    </nav>
    <PopupComponent :showClose="false" v-if="showPopup" @close="closePopup">
      <SearchPopupComponent @close="closePopup" :forceSearch="true" />
    </PopupComponent>
  </div>
</template>
<script>
/* eslint-disable */
/*global bootstrap*/
import {mapGetters} from "vuex";
import {fetch2} from "@/modules/configuration.js";
import headerMobileMenu from "@/assets/icons/header-mobile-menu.svg";
import HorizontalSplitter from "@/components/generic/HorizontalSplitter.vue"
import SvgImage from "@/components/generic/SvgImage";
import PopupComponent from '@/components/PopupComponent.vue';
import SearchPopupComponent from '@/components/popup/SearchPopupComponent.vue';
export default {
  components: {
    HorizontalSplitter,
    SvgImage,
    PopupComponent,
    SearchPopupComponent
  },
  props: {
    initialData: {},
    inert: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuIcon: headerMobileMenu,
      showPopup: false,
      data: {},
      mainMenuExpanded: false,
      userMenuExpanded: false,
    }
  },
  mounted() {
    this.data = this.initialData;
    this.$store.dispatch("fetchCartQuantityData");
    this.bindNavbarA11yEvents();
  },
  beforeUnmount() {
    this.unbindNavbarA11yEvents();
  },
  computed: {
    ...mapGetters([
      'cartQuantity'
    ]),
    cartAriaLabel() {
      const n = this.cartQuantity
      if (n > 0) {
        return `עגלת קניות, ${n} פריטים`
      }
      return 'עגלת קניות'
    },
    cartLiveMessage() {
      const n = this.cartQuantity;
      if (n > 0) {
        return `עגלת קניות עודכנה, ${n} פריטים`;
      }
      return '';
    },
    userGreetingsHtml() {
      const toolbar = this.data?.toolbar;
      if (!toolbar) {
        return '';
      }
      const responsive = this.$responsive(toolbar);
      const greetingsHtml = responsive?.menu?.user?.greetings?.text_html;
      if (greetingsHtml) {
        return greetingsHtml;
      }
      // Mobile/tablet payloads may omit greetings; use desktop copy for the user menu.
      return toolbar.desktop?.menu?.user?.greetings?.text_html || '';
    }
  },
  methods: {
    bindNavbarA11yEvents() {
      const mainMenu = document.getElementById('mainmenu');
      if (mainMenu) {
        mainMenu.addEventListener('shown.bs.collapse', this.onMainMenuShown);
        mainMenu.addEventListener('hidden.bs.collapse', this.onMainMenuHidden);
      }
      const userMenu = document.getElementById('userDropdownMenu');
      if (userMenu) {
        userMenu.addEventListener('shown.bs.dropdown', this.onUserMenuShown);
        userMenu.addEventListener('hidden.bs.dropdown', this.onUserMenuHidden);
      }
    },
    unbindNavbarA11yEvents() {
      const mainMenu = document.getElementById('mainmenu');
      if (mainMenu) {
        mainMenu.removeEventListener('shown.bs.collapse', this.onMainMenuShown);
        mainMenu.removeEventListener('hidden.bs.collapse', this.onMainMenuHidden);
      }
      const userMenu = document.getElementById('userDropdownMenu');
      if (userMenu) {
        userMenu.removeEventListener('shown.bs.dropdown', this.onUserMenuShown);
        userMenu.removeEventListener('hidden.bs.dropdown', this.onUserMenuHidden);
      }
    },
    onMainMenuShown() {
      this.mainMenuExpanded = true;
    },
    onMainMenuHidden() {
      this.mainMenuExpanded = false;
    },
    onUserMenuShown() {
      this.userMenuExpanded = true;
    },
    onUserMenuHidden() {
      this.userMenuExpanded = false;
    },
    async serverFetch(url) {
      const data = await fetch2(this, url);
      this.data = data;
    },
    openPopup(url) {
      this.$store.dispatch('showPopupWithUrl', url)
    },
    toggleMenu() {
      let myCollapse = document.getElementById('navbarNav');
      var bsCollapse = new bootstrap.Collapse(myCollapse, {toggle: false});
      bsCollapse.toggle();
      let bottomSplitter = document.getElementById('toolbarBottomSplitter');
      let bsBottomSplitter = new bootstrap.Collapse(bottomSplitter, {toggle: true});
      bsBottomSplitter.toggle();
    },
    searchPopup() {
      this.showPopup = !this.showPopup;
    },
    closePopup(refresh) {
      this.showPopup = false;
      if (refresh) {
        this.$router.go(0);
      }
    },
    clickCart() {
      // const cartElement = this.$responsive(this.data.toolbar).cart;
      // if (cartElement.popup) {
      //   this.openPopup(cartElement.href);
      // } else {
      //   this.$router.push(cartElement.href);
      // }

      if (this.$isDesktop()) {
        this.openPopup('/orders/cart_panel')
      } else {
        this.$router.push('/orders/checkout');
      }
    }
  }

}
</script>
<style scoped>
.toolbar {
  height: 60px;
  line-height: 60px;
  background-color: white;
  padding-top: 9px;
  padding-bottom: 9px;
}
.toolbar .logo {
  height: 42px;
}
.toolbar .spacer-left {
  margin-left: 20px;
}
.toolbar .toolbar-icon {
  widows: 25px;
  height: 18px;
}

.dropdown-logout-btn {
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  font: inherit;
  color: inherit;
  width: 100%;
  text-align: inherit;
}

.toolbar-cart-btn {
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font: inherit;
  color: inherit;
  line-height: 0;
  vertical-align: middle;
}

.toolbar-cart-icon-wrap {
  position: relative;
  display: inline-block;
  line-height: 0;
}
</style>